import * as React from 'react';
import { Typography, Button } from '@mui/material';
import Fluid from 'components/Fluid';

import doubleRedFlag from 'images/beachflags_double_red.svg';
import redFlag from 'images/beachflags_red.svg';
import yellowFlag from 'images/beachflags_yellow.svg';
import greenFlag from 'images/beachflags_green.svg';
import purpleFlag from 'images/beachflags_purple.svg';

const BeachFlagChart = ({ link = '/beach-safety-toolkit/' }) => {
	
	return (
		<div className="BeachFlagChart-root">
			<Fluid layout="100%" className="BeachFlagChart-headerContainer">
				<Typography variant="h3" className="BeachFlagChart-header" component="div">Beach Flag Warnings</Typography>
				<Typography variant="body1" className="BeachFlagChart-subtitle">*Entering the Gulf during double red flag conditions can result in a $500 fine and criminal charges.</Typography>
				<Button href={link} variant="underlined" className="BeachFlagChart-button">View Beach Safety & Rules</Button>
			</Fluid>
			<Fluid layout="1/3" className="BeachFlagChart-row" justifyContent="center">
				<div className="BeachFlagChart-flagContainer BeachFlagChart-flagContainerDoubleRed">
					<img width="100" height="100" src={doubleRedFlag} alt="Water Closed Flag" />
					<Typography variant="h4" component="div" className="BeachFlagChart-flagName">Water Closed To Public</Typography>
					<Typography variant="body2" className="BeachFlagChart-flagDescription">Water activity is prohibited*</Typography>
				</div>
				<div className="BeachFlagChart-flagContainer BeachFlagChart-flagContainerRed">
					<img width="100" height="100" src={redFlag} alt="High Hazard Flag" />
					<Typography variant="h4" component="div" className="BeachFlagChart-flagName">High Hazard</Typography>
					<Typography variant="body2" className="BeachFlagChart-flagDescription">High surf and/or strong currents</Typography>
				</div>
				<div className="BeachFlagChart-flagContainer BeachFlagChart-flagContainerYellow">
					<img width="100" height="100" src={yellowFlag} alt="Medium Hazard Flag" />
					<Typography variant="h4" component="div" className="BeachFlagChart-flagName">Medium Hazard</Typography>
					<Typography variant="body2" className="BeachFlagChart-flagDescription">Moderate surf and/or currents</Typography>
				</div>
			</Fluid>
			<Fluid layout="1/2" className="BeachFlagChart-row" justifyContent="center">
				<div className="BeachFlagChart-flagContainer BeachFlagChart-flagContainerGreen">
					<img width="100" height="100" src={greenFlag} alt="Low Hazard Flag" />
					<Typography variant="h4" component="div" className="BeachFlagChart-flagName">Low Hazard</Typography>
					<Typography variant="body2" className="BeachFlagChart-flagDescription">Calm conditions, exercise caution</Typography>
				</div>
				<div className="BeachFlagChart-flagContainer BeachFlagChart-flagContainerPurple">
					<img width="100" height="100" src={purpleFlag} alt="Medium Hazard Flag" />
					<Typography variant="h4" component="div" className="BeachFlagChart-flagName">Stinging Marine Life</Typography>
					<Typography variant="body2" className="BeachFlagChart-flagDescription">Man O’ War, jellyfish, stingrays</Typography>
				</div>
			</Fluid>
		</div>
	)
}

export default BeachFlagChart;